import React from "react";
import {Dropdown} from "semantic-ui-react";
import {Dialog} from "../../../Dialogs/Dialog";
import Button from "../../../Button";
import {ISelectFieldValue} from "../../VirtualizedTableInterfaces";

interface SelectDialogProps {
    open: boolean;
    title: string;
    dialogText: string;
    cellKey: string;
    value: ISelectFieldValue;
    onChange: (value: any) => void;
    onClose: () => void;
    customStyle ?: {[key: string]: string};
}

interface SelectDialogState {
    selectedItem: any;
}

export default class SelectDialog extends React.Component<SelectDialogProps, SelectDialogState> {
    constructor(props: SelectDialogProps) {
        super(props);

        this.state = {
            selectedItem: this.props.value.value
        };
    }

    private handleSubmit = () => {
        if (!this.props.open || !this.props.onChange) {
            return;
        }

        this.props.onChange(this.state.selectedItem);
    }

    public render() {
        const payload: ISelectFieldValue = this.props.value;
        if (!payload || !payload.options || payload.options.length === 0)
            return null;

        return (
            <Dialog
                open={this.props.open}
                title={this.props.title}
                actions={[
                    <Button
                        key={"submitButton"}
                        icon={"checkmark"}
                        onClick={this.handleSubmit}
                    />,
                    <Button
                        key={"cancelButton"}
                        icon={"ban"}
                        onClick={this.props.onClose}
                    />
                ]}
            >

                <p>{this.props.dialogText}</p>

                <Dropdown
                    search={true}
                    disabled={!this.props.open}
                    fluid={true}
                    selection={true}
                    value={this.state.selectedItem}
                    options={payload.options}
                    onChange={(e, v) => this.setState({selectedItem: v.value})}
                    style={this.props.customStyle ? this.props.customStyle: {}}
                />
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Table/components/modalDropdown/SelectDialog.tsx